import { addUnit, editUnit } from "../../../api/unit/unit";
import { AddUpperUnit } from ".";
import { Button } from "../../Button";
import { CloseBtn } from "../../CloseBtn";
import { Col, Row } from "react-grid-system";
import { DatePicker } from "../../DatePicker";
import { Field, Form, Formik } from "formik";
import { Link } from "react-router-dom";
import { StyledField } from "../../../styles/StyledField";
import { StyledModal, StyledNonScrollableModal } from "../../../styles/StyledModal";
import { StyledUnitActions } from "../../../styles/StyledUnit";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUnitContext } from "../../../context/unitContext";
import CloseIcon from "../../../assets/img/icons/close.svg";
import EditIcon from "../../../assets/img/icons/edit.svg";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import moment from "moment";
import PropTypes from "prop-types";
import SaveIcon from "../../../assets/img/icons/save.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function UnitHeaderEdit({ edit, newUnit, disableEditingMode, refetch }) {
	const navigate = useNavigate();
	const { axiosPrivate } = useAxiosPrivate();

	const { id, name, startDate, endDate, parent } = useUnitContext();

	const [modalIsOpen, setIsOpen] = useState(false);
	const [selectedUpperUnit, setSelectedUpperUnit] = useState(parent ? parent : null);

	useEffect(() => {
		Modal.setAppElement("body");
	});

	const initialValues = {
		name: name ? name : "",
		startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
		endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
	};

	const submitHandler = (values) => {
		if (newUnit)
			addUnit(
				axiosPrivate,
				navigate,
				selectedUpperUnit ? { ...values, parent: parseInt(selectedUpperUnit.id) } : { ...values, parent: null }
			);
		if (!newUnit)
			editUnit(
				axiosPrivate,
				id,
				selectedUpperUnit ? { ...values, parent: parseInt(selectedUpperUnit.id) } : { ...values, parent: null },
				() => {
					disableEditingMode();
					refetch();
				}
			);
	};

	return (
		<>
			<Formik initialValues={initialValues} onSubmit={(values) => submitHandler(values)}>
				{() => (
					<Form>
						<Row>
							<Col sm={5}>
								<StyledField edit>
									<label>name</label>
									<Field as="textarea" id="name" name="name" data-testid="name" />
								</StyledField>
								<StyledField>
									<label>
										upper unit
										{!selectedUpperUnit && (
											<Button bg={false} small={true} icon={EditIcon} initial onClick={() => setIsOpen(true)}>
												Add upper unit
											</Button>
										)}
									</label>
									{selectedUpperUnit && (
										<StyledField>
											<div className="wrapper">
												<span>{selectedUpperUnit.name}</span>
												<CloseBtn onClick={() => setSelectedUpperUnit(null)} icon={CloseIcon} small />
											</div>
										</StyledField>
									)}
								</StyledField>
							</Col>
							<Col sm={6} offset={{ sm: 1 }}>
								<Row>
									<Col sm={4} xl={3} xxxl={2}>
										<StyledField edit>
											<label>Start Date</label>
											<DatePicker id="startDate" name="startDate" data-testid="startDate" autoComplete="off" />
										</StyledField>
									</Col>
									<Col sm={4} xl={3} xxxl={2}>
										<StyledField edit>
											<label>End Date</label>
											<DatePicker id="endDate" name="endDate" data-testid="endDate" autoComplete="off" />
										</StyledField>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row>
							<Col sm={5}>
								<StyledUnitActions>
									{newUnit && <Link to="/">cancel</Link>}
									{edit && (
										<Button onClick={disableEditingMode} bg={false} small={true}>
											cancel
										</Button>
									)}
									<Button type="submit" icon={SaveIcon}>
										save changes
									</Button>
								</StyledUnitActions>
							</Col>
						</Row>
					</Form>
				)}
			</Formik>
			<Modal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)} style={StyledNonScrollableModal} appElement={document.getElementById("app")}>
				<ModalHeader onClick={() => setIsOpen(false)}>Add Upper Unit</ModalHeader>
				<AddUpperUnit onClick={() => setIsOpen(false)} selectedUpperUnit={setSelectedUpperUnit} id={id} isNew={newUnit ? true : false} />
			</Modal>
		</>
	);
}

UnitHeaderEdit.propTypes = {
	data: PropTypes.object,
	disableEditingMode: PropTypes.func,
	refetch: PropTypes.func,
	edit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	newUnit: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};
